import React, { useContext, useEffect, useState } from 'react'
import { CustomModal } from '../../CustomModal/CustomModal';
import { Button, Spinner } from 'reactstrap';
import { t } from 'i18next';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import peopleToVisitSuccessIcon from '../../../assets/icons/people-to-visit-success-icon.svg';
import CustomPagination from '../../CustomPagination/CustomPagination';
import { PeopleToVisitSearcher } from './PeopleToVisitSearcher';
import { ListOfPeopleToVisit } from './ListOfPeopleToVisit';
import PeopleToVisitManagementContext from '../../../context/PeopleToVisitContext/PeopleToVisitManagementContext';

export const PeopleToVisitManagement = () => {

    const { peopleToVisitManagementState, getPeopleToVisitManagement, cleanPeopleToVisitState, deletePerson } = useContext(PeopleToVisitManagementContext);
    const { peopleToVisitToConfig, filters, totalPages, responsePeopleToVisitService, isFetching } = peopleToVisitManagementState;

    const [showWarningModalToDelete, setShowWarningModalToDelete] = useState({
        active: false,
        person: {}
    });

    const handleChangePage = (page) => {
        getPeopleToVisitManagement({
            ...filters,
            regFrom: page,
        })
    }

    const openWarningModalToDelete = (person) => setShowWarningModalToDelete({ active: true, person: person });
    const closeWarningModalToDelete = async () => setShowWarningModalToDelete({ active: false, person: {} });

    const deletePersonAndRefresh = async () => {
        closeWarningModalToDelete();
        await deletePerson(showWarningModalToDelete.person.peopleToVisitId);
    }

    const undertoodAndRefresh = async () => {
        const originalFilters = {
            searchText: '',
            regFrom: 1,
            pageLength: filters.pageLength
        }
        await getPeopleToVisitManagement(originalFilters);
    };

    useEffect(() => {
        getPeopleToVisitManagement(filters);
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        cleanPeopleToVisitState();
        // eslint-disable-next-line
    }, [peopleToVisitToConfig]);

    return (
        <>

            <CustomModal showModal={responsePeopleToVisitService.show} centered={true} setShowModal={undertoodAndRefresh}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={responsePeopleToVisitService.type === 'ERROR' ? errorIcon : peopleToVisitSuccessIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{responsePeopleToVisitService.text}</p>
                    <p type="button" className='custom-modal-btn-ok' onClick={undertoodAndRefresh}>{t('UNDERSTOOD')}</p>
                </div>
            </CustomModal>

            <CustomModal showModal={showWarningModalToDelete.active} centered={true} setShowModal={closeWarningModalToDelete}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={errorIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{`${t('ARE_YOU_SURE_DELETE')} ${showWarningModalToDelete.person.documentNumber} - ${showWarningModalToDelete.person.name} ${showWarningModalToDelete.person.lastName}?`}</p>
                </div>
                <div className='d-flex align-items-center justify-content-around'>
                    <div>
                        <p type='button' className='m-0' onClick={() => closeWarningModalToDelete()}>{t('CANCEL')}</p>
                    </div>
                    <div>
                        <Button style={{ color: '#FFFF' }} className='btn-danger' onClick={() => deletePersonAndRefresh()}>
                            {t('DELETE')}
                        </Button>
                    </div>
                </div>
            </CustomModal >

            <PeopleToVisitSearcher searchFunction={getPeopleToVisitManagement} filters={filters} />

            {isFetching ?
                <div className="d-flex mt-4 justify-content-center">
                    <Spinner />
                </div>

                :

                <div className='itemsList'>
                    {
                        peopleToVisitToConfig.length ?
                            peopleToVisitToConfig.map((person, i) => {
                                return (
                                    <div key={i} className='mb-2'>
                                        <ListOfPeopleToVisit
                                            person={person}
                                            openWarningModalToDelete={openWarningModalToDelete}
                                        />
                                    </div>
                                )
                            })
                            : <div><EmptyStateOne message={t('NO_DATA_SEARCH')} /></div>
                    }
                </div>
            }

            <div className="d-flex justify-content-center">
                <CustomPagination
                    totalPages={totalPages}
                    page={filters.regFrom}
                    setPage={handleChangePage}
                    disabled={isFetching}
                />
            </div>
        </>
    )
}
